import { DetectionResults } from "../scanview/types/Detector";

export type Guidance = { message: string; color: "notDetected" | "detected" };

export class ScanGuidance {
  private lastClasses: string[] = [];
  private flipCount = 0;
  private readonly MAX_FLIPS = 3;

  record(pred: string) {
    this.lastClasses.push(pred);
    if (this.lastClasses.length >= 2) {
      const [a, b] = this.lastClasses.slice(-2);
      if (a !== b) this.flipCount++;
    }
    if (this.lastClasses.length > 5) this.lastClasses.shift();
  }

  needsRelaxation() {
    return this.flipCount >= this.MAX_FLIPS;
  }

  reset() {
    this.lastClasses = [];
    this.flipCount = 0;
  }
}

export class ScanGuidanceUI {
  private lastMsg = "";
  private freezeUntil = 0;

  constructor(
    private readonly T: {
      highDetail: number;
    }
  ) {}

  get(results: DetectionResults): Guidance {
    const now = Date.now();
    if (now < this.freezeUntil) {
      return { message: this.lastMsg, color: "detected" };
    }

    const isFrontOrBackCard =
      results.modelClass === "card_front" || results.modelClass === "card_back";
    if (isFrontOrBackCard && results.rejected === true) {
      switch (results.rejectionReason) {
        case "likely_too_far":
          return this.freeze("Move card closer", 1500);
        case "likely_too_blurry":
          return this.freeze(
            "Card is too blurry - move to brighter location",
            1500
          );
      }
    }

    if (isFrontOrBackCard && results.laplaceVariance > this.T.highDetail) {
      return this.freeze("Move card further away", 1500);
    }

    return {
      message: "",
      color: isFrontOrBackCard ? "detected" : "notDetected",
    };
  }

  private freeze(msg: string, ms: number): Guidance {
    this.lastMsg = msg;
    this.freezeUntil = Date.now() + ms;
    return { message: msg, color: "detected" };
  }
}
